import { useState, useContext } from "react";
import { Tabs, Tab } from "react-bootstrap";

import { PermissionContext } from "../../../hooks/PermissionContext";

import Sidebar from "../../../components/Navigation/Sidebar";
import Topbar from "../../../components/Navigation/Topbar";
import Header from "../../../components/Page/header";

import BankingOrdersTable from "./table";
import { OrderPaymentStatusEnum } from "../../../utils/enumsUtil";

const BankingOrders = () => {
    const [activeTab, setActiveTab] = useState('pending');
    
    const { hasPermission } = useContext(
        PermissionContext
    )

    const handleSelectTab = (key) => {
        setActiveTab(key);
    }

    const renderTabs = () => {
        // Si el usuario es tipo cliente se renderiza los tab en cuestión
        if (hasPermission("feature:isClient"))
            return (
                <>
                    <Tabs
                        id="banking-orders-tabs"
                        activeKey={activeTab}
                        onSelect={handleSelectTab}
                        className="mb-3"
                        mountOnEnter
                        unmountOnExit
                    >
                        <Tab eventKey="pending" title="Pendiente">
                            {activeTab === 'pending' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.PENDING]} />
                            )}
                        </Tab>
                        <Tab eventKey="processed" title="Procesada">
                            {activeTab === 'processed' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.AUTHORIZED, OrderPaymentStatusEnum.PAID]} />
                            )}
                        </Tab>
                        <Tab eventKey="forManagement" title="Pendiente por Gestionar">
                            {activeTab === 'forManagement' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.EXPIRED, OrderPaymentStatusEnum.FAILED]} />
                            )}
                        </Tab>
                        <Tab eventKey="issues" title="Incidencia">
                            {activeTab === 'issues' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.CANCELLED, OrderPaymentStatusEnum.COD_CONFIRMED]} />
                            )}
                        </Tab>
                    </Tabs>
                </>
            )

            // Si el usuario no es cliente se renderiza tabs defecto
            return (
                <>
                    <Tabs
                        id="banking-orders-tabs"
                        activeKey={activeTab}
                        onSelect={handleSelectTab}
                        className="mb-3"
                        mountOnEnter
                        unmountOnExit
                    >
                        <Tab eventKey="pending" title="Pendiente">
                            {activeTab === 'pending' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.PENDING]} />
                            )}
                        </Tab>
                        <Tab eventKey="processed" title="Procesada">
                            {activeTab === 'processed' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.AUTHORIZED, OrderPaymentStatusEnum.PAID]} />
                            )}
                        </Tab>
                        <Tab eventKey="issues" title="Incidencia">
                            {activeTab === 'issues' && (
                                <BankingOrdersTable activeTab={activeTab} statuses={[OrderPaymentStatusEnum.FAILED, OrderPaymentStatusEnum.CANCELLED, OrderPaymentStatusEnum.COD_CONFIRMED, OrderPaymentStatusEnum.EXPIRED]} />
                            )}
                        </Tab>
                    </Tabs>
                </>
            )
    }

    return (
        <div>
            <div id='wrapper'>
                <Sidebar />
                <div id='content-wrapper' className='d-flex flex-column'>
                    <div id='content'>
                        <Topbar />
                        <div className='container-fluid'>
                            <Header title={"Órdenes"} subtitle={"Módulo para la gestión de las órdenes creadas con pago eléctronico"} />
                            <div className='card shadow mb-4'>
                                <div className='card-header py-3'>
                                    {renderTabs()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BankingOrders;